import { Slider } from "@mui/material";
import React, { useEffect } from "react";
import "./rangeSelector.css";

const RangeSelector = ({
  heading,
  initialvalue,
  start,
  end,
  step = 1,
  min = 0,
  max = 100,
  handleCommitedChange,
}) => {
  const [value, setValue] = React.useState(initialvalue || []);

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  useEffect(() => {
    setValue(initialvalue);
  }, [initialvalue]);

  min = parseFloat(min);
  max = parseFloat(max);

  const formatValueLabel = (value) => {
    return value.toFixed(2);
  };

  return (
    <section className="rangeSelector">
      <h5>{heading}</h5>
      <Slider
        sx={{
          width: 225,
          color: "#787878",
          height: 3,
          "& .MuiSlider-thumb": {
            width: "16px",
            height: "16px",
            backgroundColor: "#ffffff",
            border: "2px solid #787878",
          },
        }}
        min={min}
        max={max}
        step={step}
        getAriaLabel={() => "Minimum distance shift"}
        value={value}
        onChange={handleChange}
        valueLabelDisplay="auto"
        onChangeCommitted={(event, newValue) =>
          handleCommitedChange(newValue, heading)
        }
        getAriaValueText={(value) => value.toFixed(2)}
        valueLabelFormat={formatValueLabel}
      />

      <div className="StartEndRange">
        <span>{start}</span>
        <span>{end}</span>
      </div>
    </section>
  );
};

export default RangeSelector;
